import { AxiosInstance } from 'axios';
import { ApiService } from '../model/Api.model';
import { IDiscountsConfig } from '../interface/discount/IDscountConfig';

enum DiscountsConfigServiceEnum {
  get = "/",
}

export default class DiscountsConfigService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/discounts-config");
  }

  public all = async (): Promise<IDiscountsConfig[]> => await this.GET(DiscountsConfigServiceEnum.get);
}
